<div *ngIf="form" [formGroup]="form" class="fb-editor">
  <fb-wrap-panel class="columns-panel" [xOffset]="32" [yOffset]="0">
    <fb-environment-check [environments]="debugEnvironments">
      <ng-container *ngIf="config?.showDebug || showDebug">
        <div class="cell" fxFlex="100%" [innerHTML]="form | formDebug | async"></div>
      </ng-container>
    </fb-environment-check>
    <ng-container *ngFor="let column of config?.items | editorColumns">
      <ng-container *fbWrapPanelItem="column.width; visibility: column | editorItemVisibility">
        <div
          class="{{ column.cssClass | editorCssClass }}"
          [ngClass.xl]="column.cssClass | editorCssClass : 'xl'"
          [ngClass.lg]="column.cssClass | editorCssClass : 'lg'"
          [ngClass.md]="column.cssClass | editorCssClass : 'md'"
          [ngClass.sm]="column.cssClass | editorCssClass : 'sm'"
          [ngClass.xs]="column.cssClass | editorCssClass : 'xs'"
        >
          <fb-wrap-panel class="items-panel" [xOffset]="16" [yOffset]="24">
            <ng-container *ngFor="let item of column.items">
              <ng-container *fbWrapPanelItem="item.width; visibility: item | editorItemVisibility">
                <div
                  class="{{ item.cssClass | editorCssClass }}"
                  [ngClass.xl]="item.cssClass | editorCssClass : 'xl'"
                  [ngClass.lg]="item.cssClass | editorCssClass : 'lg'"
                  [ngClass.md]="item.cssClass | editorCssClass : 'md'"
                  [ngClass.sm]="item.cssClass | editorCssClass : 'sm'"
                  [ngClass.xs]="item.cssClass | editorCssClass : 'xs'"
                >
                  <ng-container [ngSwitch]="item.type">
                    <ng-container *ngSwitchCase="specialItemTypeEnum.Title">
                      <ng-container *ngIf="item.title; else emptyTitle">
                        <h1 class="{{ item.cssClass || 'title' }}">{{ item.title }}</h1>
                      </ng-container>
                      <ng-template #emptyTitle>
                        <h1 class="title">&nbsp;</h1>
                      </ng-template>
                    </ng-container>
                    <ng-container *ngSwitchCase="specialItemTypeEnum.Content">
                      <div class="d-block h-full">
                        <ng-container
                          [ngTemplateOutlet]="[childrenTemplates, templates] | findTemplate : item.templateName"
                          [ngTemplateOutletContext]="{ $implicit: { config: item, form: form } }"
                        ></ng-container>
                      </div>
                    </ng-container>
                    <ng-container *ngSwitchCase="specialItemTypeEnum.Array">
                      <fb-array-editor
                        itemsTemplateName="_itemsTemplate"
                        [templates]="childrenTemplates | combineTemplates : templates"
                        [addButtonCaption]="item.addButtonCaption || 'Add Record'"
                        [addButtonAlign]="item.addButtonAlign || 'right'"
                        [atLeastOneItem]="item.atLeastOneItem"
                        [removeButtonClasses]="item.removeButtonClasses"
                        [canRemove]="item.canRemove"
                        [canAdd]="item.canAdd"
                        [canAction]="item.canAction"
                        [confirmRemove]="item.confirmRemove"
                        [addButtonTemplateName]="item.addButtonTemplateName"
                        [actionButtonTemplateName]="item.actionButtonTemplateName"
                        [removeButtonTemplateName]="item.removeButtonTemplateName"
                        [itemConfig]="item.editor"
                        [actionButton]="item.actionButton"
                        [form]="form?.controls[item.name]"
                      >
                        <ng-container *fbTemplate="let arrayItem of '_itemsTemplate'">
                          <div
                            class="{{ item.rowCssClass | editorCssClass }}"
                            [ngClass.xl]="item.rowCssClass | editorCssClass : 'xl'"
                            [ngClass.lg]="item.rowCssClass | editorCssClass : 'lg'"
                            [ngClass.md]="item.rowCssClass | editorCssClass : 'md'"
                            [ngClass.sm]="item.rowCssClass | editorCssClass : 'sm'"
                            [ngClass.xs]="item.rowCssClass | editorCssClass : 'xs'"
                          >
                            <ng-container *ngIf="item.itemsTemplate; else useEditor">
                              <ng-container
                                [ngTemplateOutlet]="
                                  item?.templateRef ||
                                  ([childrenTemplates, templates] | findTemplate : item.itemsTemplate)
                                "
                                [ngTemplateOutletContext]="{
                                  $implicit: {
                                    config: item,
                                    control: arrayItem.control,
                                    form: form,
                                    infiniteListScroll: infiniteListScroll,
                                    arrayItem: arrayItem.item,
                                    templates: (childrenTemplates | combineTemplates : templates)
                                  }
                                }"
                              ></ng-container>
                            </ng-container>
                            <ng-template #useEditor>
                              <fb-editor
                                [form]="arrayItem.control"
                                [config]="item.editor"
                                [templates]="childrenTemplates | combineTemplates : templates"
                                [infiniteListScroll]="infiniteListScroll"
                              ></fb-editor>
                            </ng-template>
                          </div>
                          <div
                            *ngIf="item.showSeparator && !arrayItem.last"
                            class="w-full border-bottom mb-16 mt-16"
                          ></div>
                        </ng-container>
                      </fb-array-editor>
                    </ng-container>
                    <ng-container *ngSwitchCase="specialItemTypeEnum.Editor">
                      <ng-container *ngIf="!item.templateName; else useTemplate">
                        <fb-editor
                          [form]="form?.controls[item.name]"
                          [config]="item.editor"
                          [templates]="childrenTemplates | combineTemplates : templates"
                          [infiniteListScroll]="infiniteListScroll"
                        ></fb-editor>
                      </ng-container>
                      <ng-template #useTemplate>
                        <ng-container
                          [ngTemplateOutlet]="[childrenTemplates, templates] | findTemplate : item.templateName"
                          [ngTemplateOutletContext]="{
                            $implicit: {
                              config: item,
                              control: form?.controls[item.name],
                              form: form,
                              infiniteListScroll: infiniteListScroll,
                              templates: (childrenTemplates | combineTemplates : templates)
                            }
                          }"
                        ></ng-container>
                      </ng-template>
                    </ng-container>
                    <ng-container *ngSwitchCase="specialItemTypeEnum.Gap"> </ng-container>
                    <ng-container *ngSwitchCase="fieldTypeEnum.TEMPLATE">
                      <ng-container
                        [ngTemplateOutlet]="
                          item?.templateRef || ([childrenTemplates, templates] | findTemplate : item.templateName)
                        "
                        [ngTemplateOutletContext]="{
                          $implicit: {
                            config: item | transformFieldConfig : config,
                            control: form?.controls[item.name],
                            form: form,
                            infiniteListScroll: infiniteListScroll,
                            templates: (childrenTemplates | combineTemplates : templates)
                          }
                        }"
                      ></ng-container>
                    </ng-container>
                    <ng-container *ngSwitchDefault>
                      <fb-editor-field
                        [config]="item | transformFieldConfig : config"
                        [control]="form?.controls[item.name]"
                        [templates]="childrenTemplates | combineTemplates : templates"
                        [infiniteListScroll]="infiniteListScroll"
                      ></fb-editor-field>
                    </ng-container>
                  </ng-container>
                </div>
              </ng-container>
            </ng-container>
          </fb-wrap-panel>
        </div>
      </ng-container>
    </ng-container>
  </fb-wrap-panel>
</div>
